<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>
<app-page-layout pageTitle="CORS Config">

  <div page-actions class="flex items-center gap-2">
    <p-button
      label="Add CORS"
      icon="pi pi-plus"
      (onClick)="addNewRow()"
      [disabled]="hasUnsavedRow()"
      severity="primary"
      size="small"
      outlined
    ></p-button>
  </div>

  <!-- State Container -->
  <app-state-container
    [state]="viewState()"
    loadingMessage="Loading CORS configurations..."
    loadingSubMessage="Please wait while we fetch your CORS configs"
    emptyIcon="pi-globe"
    emptyTitle="No CORS configurations found"
    [emptyMessage]="emptyStateMessage()"
    [showEmptyAction]="true"
    emptyActionLabel="Add CORS"
    emptyActionIcon="pi-plus"
    [emptyActionOutlined]="true"
    [showClearFilters]="false"
    [errorMessage]="errorMessage()"
    (emptyAction)="addNewRow()"
    (retry)="retryLoad()"
  >
    <div class="bg-white dark:bg-zinc-950 rounded-lg border border-surface-200 dark:border-zinc-800">
      <p-table
        [value]="corsConfigs()"
        [loading]="loading()"
        class="p-datatable-sm"
        [rowHover]="true"
        columnResizeMode="fit"
      >
        <!-- HEADER -->
        <ng-template pTemplate="header">
          <tr class="bg-surface-100 dark:bg-zinc-900 text-surface-600">
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 font-medium bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
            >
              Origin Pattern
            </th>
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 bg-surface-100 dark:bg-zinc-900 font-medium text-surface-700 dark:text-zinc-200"
            >
              Enabled
            </th>
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 font-medium bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
            >
              Actions
            </th>
          </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-row>
          <tr class="border-t border-surface-200 dark:border-surface-700 hover:bg-surface-50 dark:hover:bg-surface-800 transition">
            <!-- ORIGIN -->
            <td>
              @if (editingId() === row.id || row.isNew) {
                <input
                  #originInput
                  pInputText
                  [(ngModel)]="row.originPattern"
                  class="w-full"
                  placeholder="Enter origin pattern"
                  (keydown.enter)="updateRow(row)"
                  (keydown.escape)="cancelEdit()"
                />
              } @else {
                {{ row.originPattern }}
              }
            </td>

            <!-- TOGGLE -->
            <td>
              <p-toggleswitch
                [(ngModel)]="row.enabled"
                (ngModelChange)="toggleStatus(row)"
                [disabled]="row.isNew"
              ></p-toggleswitch>
            </td>

            <!-- ACTIONS -->
            <td class="px-3 py-1">
              <div class="flex gap-2 items-center">
                <!-- EDIT -->
                @if (!row.isNew && editingId() !== row.id) {
                  <button
                    pButton
                    icon="pi pi-pencil"
                    text
                    (click)="startEdit(row)"
                    size="small"
                  ></button>
                }

                <!-- SAVE / CANCEL -->
                @if (editingId() === row.id || row.isNew) {
                  <button
                    pButton
                    icon="pi pi-check"
                    severity="success"
                    text
                    size="small"
                    (click)="updateRow(row)"
                  ></button>
                  <button
                    pButton
                    icon="pi pi-times"
                    severity="secondary"
                    text
                    size="small"
                    (click)="cancelEdit()"
                  ></button>
                }

                <!-- DELETE -->
                @if (!row.isNew && editingId() !== row.id) {
                  <button
                    pButton
                    icon="pi pi-trash"
                    severity="danger"
                    text
                    size="small"
                    (click)="deleteRow(row)"
                  ></button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </app-state-container>
</app-page-layout>